import axios from "axios";
const data_api = axios.create({
  baseURL: process.env.REACT_APP_MARCA_MODELO_API_URL,
  auth: {
    username: 'ECOMMERCE',
    password: '07callatm'
  },
  headers: {
    'Content-Type': 'application/json',
  }
});



export default data_api;